import { route } from '../helpers';

import { LoginPages } from '../../constants/AppConstants';

export default route(LoginPages.RESET_PASSWORD, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/login/ResetPassword').default);
        }, 'login-reset-password');
    }
});
